import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { EpGridComponent, IEpGridModel, IEpGridState, IEPGridDataResult, EpGridEvent, IEpGridSelectionOptions, EpButtonSize, EpButtonStyle, IEpComponentEventArg } from '@epicor/kinetic';
import { Observable } from 'rxjs';
import { IEpBtCardControlModel, BistrackConfig, PageNames } from 'ep-bt-controls';

import { ActivatedRoute } from '@angular/router';
import { IEpCardModel } from '@epicor/kinetic';
import {
  FieldAgentClient, GetCustomerAddressHeadersRequest, SearchParameters,
  PagingParameters, SortParameters,
  SortParametersDirection, CustomerSearchParameters,
  CustomerSearchParametersCustomerStatus, CustomerSearchParametersDeliverytype

} from 'ep-bt-field-agent-proxy';
import { Router, NavigationExtras } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';
import { Location } from '@angular/common';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';

declare var $: any;


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-addresses-grid',
  templateUrl: './epbt-fa-addresses-grid.component.html',
  styleUrls: ['./epbt-fa-addresses-grid.component.scss']
})
export class EpbtFaAddressesGridComponent implements OnInit {

  EpButtonStyle = EpButtonStyle;
  private _customerId: number;
  address: any;
  @Input() customerId: number;

  private _searchString: string;

  @Input('searchString') set searchString(value: string) {
    this._searchString = value;
  }

  get searchString(): string { return this._searchString; }

  @ViewChild('addressMapTemplate', {static: false}) addressMapTemplate: TemplateRef<any>;
  @ViewChild('addressTemplate', {static: false}) addressTemplate: TemplateRef<any>;

  @ViewChild(EpGridComponent, {static: false}) grid: EpGridComponent;

  showGrid = true;
  public gridModel: IEpGridModel;
  public pageSize = 10;
  public cards: Array<IEpBtCardControlModel>;

  cardModels: IEpGridModel[] = [];
  cardModel: IEpGridModel;
  webTrackUser: any;
  customerAddressRequest: GetCustomerAddressHeadersRequest;
  paging: PagingParameters;
  sort: SortParameters;
  webtrackResult: any;

  @Output() loadingChange = new EventEmitter<boolean>();
  addressCollection: any = [];
  totalPages = 1;
  pageArray: Array<number> = [];
  lastPage: number;
  lastRecords: any;
  mobileData: any;
  isLastRecords = false;
  isMoreEnable = false;

  // @Input() isPopup: boolean = false;

  constructor(private client: FieldAgentClient,
    private route: ActivatedRoute, private router: Router,
    private fieldAgentService: EpbtFieldAgentService,
    private config: BistrackConfig, private customerService: EpbtFaCustomerService,
    private location: Location,
    private quickOrderService: EpbtFaQuickOrderService,
    private sortService: EpbtFaSortService) { }



  ngOnInit() {
    this._customerId = this.customerId;
    // var bistrackSettings = this.fieldAgentService.getBisTrackSetting();

    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.pageSize = bistrackSettings.searchPageSize;
    });


    // this.webTrackUser = this.fieldAgentService.getWebTrackUser();

    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.gridModel = this.getGridModel([]);
    });
    // this.gridModel = this.getGridModel();
    // this.getGridData();
    // this.fieldAgentService.getWebTrackUser().subscribe(webTrackRes => {
    //       this.webTrackUser = webTrackRes;
    //       console.log(this.webTrackUser, 'address webstrack user id');
    //       this.gridModel = this.getGridModel();
    //       this.getGridData();
    // });

  }


  // grid model start
  getGridModel(addressList): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'addressCode',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: false,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      selectable: this.quickOrderService.isNewOrder ? true : false,
      data: addressList,
      columns: [
        { field: 'addressCode', title: 'ADDRESS CODE', width: 80, hidden: false },
        { field: 'jobRef', title: 'JOB REFERNCE', width: 60, hidden: false },
        { field: 'address', title: 'ADDRESS', width: 120, hidden: false, cellTemplate: this.addressTemplate },
        { field: 'map', title: 'MAP', width: 50, hidden: false, class: 'color-blue', cellTemplate: this.addressMapTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.navigateToDetailsView(eventArg.event.dataItem);
        }
      },
      loader: (epGrid: EpGridComponent, state: IEpGridState) => {
        const observerResult = this.getGridModelData(epGrid, state, addressList, false);
        return observerResult;
      }
    };

    $(window).resize(() => {
      this.updateGrid();
    });

    return model;
  }


  getGridModelData(epGrid: EpGridComponent, state: IEpGridState, addressList, isMobile: boolean): Observable<IEPGridDataResult> {
    const observerResult = new Observable<IEPGridDataResult>(observer => {
      const index = state.skip + state.take;
      const pageNumber = Math.ceil(index / state.take);
      const pageIndex = this.pageArray.indexOf(pageNumber);
      if ((pageIndex >= 0 && !isMobile) || (pageNumber == this.lastPage && this.lastRecords && this.lastRecords.length > 0 && !isMobile)) {
        epGrid.model.loadingIndicator = false;
        const showoff = pageNumber == this.lastPage ? this.lastRecords : this.addressCollection.slice(state.take * pageIndex, (state.take * pageIndex) + state.take);
        const result: IEPGridDataResult = {
          data: showoff,
          total: this.totalPages
        };
        observer.next(result);
        observer.complete();
      } else {
        if (!isMobile) {
          epGrid.model.loadingIndicator = true;
        }

        const searchCustomerParams = new CustomerSearchParameters();
        searchCustomerParams.customerId = this.customerId ? this.customerId : -1;
        searchCustomerParams.webTrackCustomersOnly = false;
        searchCustomerParams.defaultOnly = false;

        this.paging = new PagingParameters();
        this.paging.index = state.skip;
        this.paging.count = this.pageSize;
        searchCustomerParams.paging = this.paging;

        this.sort = new SortParameters();
        this.sort.sortColumn = this.sortService.dashboardAddressSortValue; // 'AddressCode';
        this.sort.direction = this.sortService.dashboardAddressDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
        searchCustomerParams.sorting = this.sort;

        searchCustomerParams.bisTrackUserHasReadAccessToTheseBranchIDs = null;
        searchCustomerParams.bisTrackUserID = 0;
        searchCustomerParams.branchID = 0;
        searchCustomerParams.competitor = 0;
        searchCustomerParams.customerStatus = CustomerSearchParametersCustomerStatus.NotSet;
        searchCustomerParams.customersLimitSearchToHomeBranch = false;
        searchCustomerParams.deliverytype = CustomerSearchParametersDeliverytype.All;
        searchCustomerParams.includeMOLTProducts = false;
        // searchCustomerParams.paging = null;
        searchCustomerParams.priceLevels = null;
        searchCustomerParams.productGroupId = 0;
        searchCustomerParams.quicklistId = 0;
        searchCustomerParams.refineIDs = null;
        searchCustomerParams.refineValues = null;
        searchCustomerParams.restrictCustomersToSalesRep = false;
        searchCustomerParams.restrictProductGroupsToCustomer = false;
        searchCustomerParams.searchPermissions = null;
        searchCustomerParams.searchText = this._searchString;
        searchCustomerParams.showProductsInCurrentGroupOnly = false;
        // searchCustomerParams.sorting = this.faService.sorting('', SortParametersDirection.Ascending);

        this.client.findAddresses(searchCustomerParams).subscribe(res => {
          if (res && res.lines && res.lines.length > 0) {
            addressList = res.lines;
            this.totalPages = res.resultCount;
            this.lastPage = Math.ceil(this.totalPages / state.take);
            if (pageNumber != this.lastPage) {
              this.pageArray.push(pageNumber);
            }

            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            if (addressList.length < state.take) {
              this.lastRecords = addressList;
            } else {
              this.addressCollection = [...this.addressCollection, ...addressList];
            }
            if (!isMobile) {
              this.mobileData = this.addressCollection;
              if (this.lastRecords && this.lastRecords.length > 0) {
                this.mobileData = [...this.mobileData, ...this.lastRecords];
              }
              this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
            }

            length = this.addressCollection.length;
            const result: IEPGridDataResult = {
              data: addressList,
              total: this.totalPages
            };
            observer.next(result);
            observer.complete();
          } else {
            const result: IEPGridDataResult = {
              data: [],
              total: 0
            };
            observer.next(result);
            observer.complete();
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            this.isMoreEnable = false;
            this.mobileData = this.mobileData ? this.mobileData : [];
          }
        });
      }
      this.loadingChange.emit(false);
    });
    return observerResult;
  }

  // grid model end

  // grid height calculation start
  getHeight(): number {
    const height = $(window).outerHeight() - 192;
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }
    return height;
  }
  // grid height calculation end

  // This method will combines the full address of map
  getAddressData(addressObj: any): string {
    const address = [addressObj.address1, addressObj.address2,
    addressObj.address3, addressObj.city,
    addressObj.county, addressObj.postCode, addressObj.country].filter(Boolean).join(', ');
    return address;
  }

  updateGrid() {
    this.gridModel.height = this.getHeight();
  }
  // address field mapping end


  // add button function start

  getMobileData() {
    const take = this.pageSize;
    for (let i = 1; i <= this.lastPage; i++) {
      const index = this.pageArray.indexOf(i);
      if (index == -1) {
        const state: IEpGridState = {
          skip: (i - 1) * take,
          take: take
        };
        let epGrid: EpGridComponent;
        this.getGridModelData(epGrid, state, [], true).subscribe(res => {
          if (res.data && res.data.length > 0) {
            let j = 0;
            if (res.data.length == state.take) {
              res.data.forEach(element => {
                this.mobileData.splice((state.take * (i - 1)) + j, 0, element);
                j++;
              });
            }
            if (this.lastRecords && this.lastRecords.length > 0 && !this.isLastRecords) {
              this.mobileData = [...this.mobileData, ...this.lastRecords];
              this.isLastRecords = true;
            }
            this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
          }
        });
        break;
      }
    }
  }


  updateGridData() {
    this.addressCollection.length = 0;
    this.lastPage = 0;
    this.lastRecords = undefined;
    this.mobileData = undefined;
    this.isLastRecords = false;
    this.pageArray.length = 0;
    this.isMoreEnable = false;
    this.gridModel = undefined;
    this.showGrid = false;
    this.addressCollection.length = 0;
    setTimeout(() => {
      this.showGrid = true;
      this.loadingChange.emit(true);
      this.gridModel = this.getGridModel([]);
    }, 200);
  }

  navigateToDetailsView(args) {
    if (this.customerService.fromPage == PageNames.QuickOrder) {
      if (!this.quickOrderService.isNewOrder) {
        // this.quickOrderService.quickOrder.deliveryAddress = args;
        this.quickOrderService.setAddress(args, (flag: any) => { this.router.navigate(['/home/quickorder']); });
        this.customerService.fromPage = PageNames.CustomerSearch;
        // this.location.back();
      } else {
        this.quickOrderService.addressForDesktop = args;
      }
    } else {
      this.router.navigate(['/home/customer/addaddress', this.customerId, args.userData.id]);
    }
  }

  onCardClick(model) {
    this.navigateToDetailsView(model);
  }
  // add button function end
}
